import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import {Link } from "react-router-dom";
import {withRouter} from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import Entrance from './Entrance';
import Sidebar from '../component/sidebar';
import NoteList from '../component/NoteList';
import NotePage from '../component/NotePage';
import Recommend from '../component/Recommend';
import BigTitle from '../component/BigTitle';
import Navbar from '../component/Navbar';
import StarLabel from '../component/StarLabel';


@withRouter
@inject("store")
@observer

export default class Editor extends Component
{

    componentDidMount()
    {
        if( window.innerWidth <= 800 )
        {
            this.props.store.view_type = 1;
        }
    }

    
    
    constructor(props){
        super(props);
        this.state = { "changing":1 };
        this.changestate = this.changestate.bind(this);
        
    }

    changestate(){
        this.setState({"changing":this.props.store.starchange})
       
    }

   


    render(){
        const view_type = this.props.store.view_type;
        const main = <><Navbar/><div className ="editorbox">
              { view_type == 0  && <> 
             <Sidebar  />
              
            <NoteList changing = {this.state.changing}/>
         
            {this.props.store.is_title == 0 &&<Recommend/>}
            {this.props.store.is_title == 1 &&<NotePage changefatherstate = {this.changestate} />}
            {this.props.store.is_title == 2 &&<BigTitle changefatherstate = {this.changestate}/> }</> }

            {  view_type == 1 && <Sidebar changing = {this.state.changing}/> }
            { view_type == 2 && <NoteList/> }
            {  view_type == 3 && <>  
            {this.props.store.is_title == 0 &&<Recommend/>}
            {this.props.store.is_title == 1 &&<NotePage changefatherstate = {this.changestate}/>}
            {this.props.store.is_title == 2 &&<BigTitle changefatherstate = {this.changestate}/>}</> }
        
        
         </div></>;
        
        
        return <div>

{window.localStorage.getItem("firstenter") == "1"?<>
<DocumentTitle title={this.props.store.appname}>{main}</DocumentTitle>
          </>:<>
         <Entrance/>
            </>}
          
    </div>
    }
}